import {
  Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	FormControl,
	FormLabel,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TPDropDown from "./TPDropDown";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { api } from "../../redux/api";
import { inboundTemplateToRcTree } from "../../utils/rctreeDataConversion";
import { filterOutNodeTypes } from "../../utils/utilFunctions";
import { SectionHeader } from "../ItemProperties/Forms/SectionHeader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const InboundDependency = ({ datatype }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const parentScreen = useContext(ParentScreenCtx);
	const [template, setTemplate] = useState(t(""));
	const [workflow, setWorkflow] = useState(t("SELECT"));
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");
	const [inboundWorkflow, setInboundWorkflow] = useState([]);
	const [inboundTemplate, setInboundTemplate] = useState([]);
	const [workflowOptions, setWorkflowOptions] = useState([]);
	const [templateOptions, setTemplateOptions] = useState([]);
	const [errorMessage, setErrorMessage] = useState({
		workflow: "",
		template: ""
	});
	const currentScreen = useSelector((state) => state.treeData.currentScreen);
	const inboundTemplateTree = useSelector(
		(state) => state.treeData.inbound.leftTree.tree.body.translatedData
	);
	const templateHeader = useSelector(
		(state) => state.treeData.outbound.rightTree.tree.templateHeader
	);
	const initialTemplateHeader = useSelector(
		(state) => state.treeData.outbound.rightTree.tree.initialTemplateHeader
	);
	const { account } = useSelector((state) => state?.queryParams || "");

	const workflowHandler = (e) => {
		let { value } = e.target;
		handleChange("DEPENDENCIES", "");
		setWorkflow(value);
		setTemplate("");
		setErrorMessage({
			workflow: "",
			template: ""
		});
	};

	const inboundHandler = (e) => {
		let { value } = e.target;
		if ([t("EMPTY_COMBO"), t("SELECT")].includes(value))
			handleChange("DEPENDENCIES", "");
		else handleChange("DEPENDENCIES", `${workflow}/inbound_templates/${value}`);
		setTemplate(value);
		setErrorMessage({
			workflow: "",
			template: ""
		});
	};

	const handleChange = (key, value) => {
		dispatch(
			treeActions.setRightTreeTemplateHeaders({
				screen: parentScreen,
				key,
				value,
			})
		);
	};

	const viewTemplateHandler = () => {
		dispatch(treeActions.setCurrentScreen("inbound"));
		dispatch(
			treeActions.setLeftTreeContextActionValue({
				screen: "inbound",
				data: {
					workflowGroup: workflow,
					name: template,
				},
			})
		);
	};

	const valueToBoolean = (val) => {
		return val
			? (typeof val === "boolean" && val) || val === "TRUE" || false
			: false;
	};

	useEffect(() => {

		if(!inboundTemplateTree || inboundTemplateTree?.length === 0) return;

		const workflows = [t("SELECT")];

		inboundTemplateTree?.forEach((ele) => {
			if (ele?.type === "workflowGroup") {
				workflows.push(ele.title);
			}
		});
		setInboundWorkflow(workflows);
	}, [currentScreen, inboundTemplateTree]);

	useEffect(() => {
		if(!inboundTemplateTree || inboundTemplateTree?.length === 0) return;
		
		const templates = [];
		inboundTemplateTree?.forEach((ele) => {
			if (ele?.title === workflow) {
				ele?.children?.forEach((t) => templates.push(t.title));
				return;
			}
		});
		templates.unshift(templates.length ? t("SELECT") : t("EMPTY_COMBO"));
		setInboundTemplate(templates);
	}, [workflow, currentScreen, inboundTemplateTree]);

	useEffect(() => {
		const workFlowMenuItems = inboundWorkflow.map((obj, key) => (
			<MenuItem key={key} value={obj}>
				{obj}
			</MenuItem>
		));
		setWorkflowOptions(workFlowMenuItems);
	}, [inboundWorkflow]);

	useEffect(() => {
		if (template === "") {
			setTemplate(
				inboundTemplate.length === 1 || workflow === t("SELECT")
					? t("EMPTY_COMBO")
					: t("SELECT")
			);
		}
		const templateMenuItems = inboundTemplate.map((obj, key) => (
			<MenuItem key={key} value={obj}>
				{obj}
			</MenuItem>
		));
		setTemplateOptions(templateMenuItems);
	}, [inboundTemplate]);

	useEffect(() => {
		const dependency = templateHeader?.DEPENDENCIES?.split("/") || [];

		setWorkflow(dependency[0] || t("SELECT"));
		setTemplate(dependency[2] || t("EMPTY_COMBO"));
		
		let foundTemplate = false;

		inboundTemplateTree?.forEach((wfg) => {
			if(wfg.title === dependency[0]) {
				wfg?.children.forEach((template) => {
					if(template.title === dependency[2]) {
						foundTemplate = true;
					}
				})
			}
		})
		const foundWorkflow = inboundTemplateTree?.some((wfg) => wfg.title === dependency[0]);

		if(!inboundTemplateTree || inboundTemplateTree?.length === 0) return;
		
		if (foundWorkflow && foundTemplate) {
			setErrorMessage({
				workflow: "",
				template: ""
			});
		} else if(templateHeader?.DEPENDENCIES && foundWorkflow && !foundTemplate) {
			setErrorMessage({
				workflow: "",
				template: dependency?.[2] ? t("INBOUND_TEMPLATE_NOT_FOUND") : ""
			});
		} else if(templateHeader?.DEPENDENCIES) {
			setErrorMessage({
				workflow: t("WORKFLOW_GROUP_NOT_FOUND"),
				template: t("INBOUND_TEMPLATE_NOT_FOUND")
			});
			dispatch(
				treeActions.setInboundDependencyTree({
					data: {
						header : [],
						body : [],
						trailer : [],
						templateHeader: {},
						isLoading: false,
						templateFound: false
					},
				})
			);
		}
	}, [initialTemplateHeader, inboundTemplateTree]);

	useEffect(() => {
		setIsLoading(true);
		if (
			![t("SELECT"), "EMPTY_COMBO"].includes(template) &&
			![t("SELECT"), "EMPTY_COMBO"].includes(workflow) &&
			workflowOptions.filter((ele) => ele?.props.value === workflow).length &&
			templateOptions.filter((ele) => ele?.props.value === template).length
		) {
			dispatch(
				treeActions.setInboundDependencyTree({
					data: {
						header: [],
						body: [],
						trailer: [],
						templateHeader: {},
						isLoading: true,
						templateFound: false
					},
				})
			);
			dispatch(
				api.endpoints.getInboundTemplateData.initiate(
					{
						workflowGroupName: workflow,
						templateName: template,
						account: account,
					},
					{ forceRefetch: true }
				)
			).then((res) => {
				if(res?.data?.TEMPLATE) {
					const header = filterOutNodeTypes(
						inboundTemplateToRcTree(res.data, "HEADER", null, true),
						["COMMENT"]
					);
					const body = filterOutNodeTypes(
						inboundTemplateToRcTree(res.data, "BODY"),
						["COMMENT"]
					);
					const trailer = filterOutNodeTypes(
						inboundTemplateToRcTree(res.data, "TRAILER"),
						["COMMENT"]
					);
					dispatch(
						treeActions.setInboundDependencyTree({
							data: {
								header,
								body,
								trailer,
								templateHeader: res.data?.TEMPLATE?.TEMPLATE_HEADER,
								isLoading: false,
								templateFound: true
							},
						})
					);
					setError("");
				}else {
					dispatch(
						treeActions.setInboundDependencyTree({
							data: {
								header: [],
								body: [],
								trailer: [],
								templateHeader: {},
								isLoading: false,
								templateFound: false
							},
						})
					);
					setError(t("SOMETHING_WENT_WRONG"))
				}
			})
			.catch(() => {
				setError(t("SOMETHING_WENT_WRONG"))
			}).finally(() =>{
				setIsLoading(false);
			})
		} else {
			dispatch(
				treeActions.setInboundDependencyTree({
					data: {
						header: [],
						body: [],
						trailer: [],
						templateHeader: {},
						isLoading: false,
					},
				})
			);
		}
	}, [template, workflow, workflowOptions, templateOptions]);

	return (
		<Box className='margin-top-25'>
			<Accordion defaultExpanded sx={styles.accordianContainer}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls='accordianFormattingOptions'
					id='accordianFormattingOptions'
					className='accordian-override'
					sx={styles.accordianHeader}
				>
					<SectionHeader text={t("LBL_IN_DEPENDANCY")} />
				</AccordionSummary>
				<AccordionDetails sx={styles.accordianContent}>
					<Stack spacing={"10px"}>
						<TPDropDown
							label={t("LBL_TEMP_GROUP")}
							options={workflowOptions}
							value={workflow}
							onChange={workflowHandler}
							extraSelectProps={{
								renderValue: (selected) => {
									return selected;
								  }
							}}
						/>
						{errorMessage?.workflow && (
							<Typography variant="body2" color="error">{errorMessage?.workflow}</Typography>
						)}

						<Stack direction={"row"} spacing={"4px"} className='stack-row'>
							<TPDropDown
								label={t("LBL_TEMP")}
								options={templateOptions}
								value={template}
								onChange={inboundHandler}
								style={{ paddingBottom: "0px !important" }}
								extraSelectProps={{
								renderValue: (selected) => {
									return selected;
								  }
							}}
							/>
							<Button
								size='small'
								disabled={[t("EMPTY_COMBO"), t("SELECT")].includes(template)}
								variant='outlined'
								sx={{
									width: "40px",
									minWidth: "40px",
								}}
								onClick={viewTemplateHandler}
							>
								{t("MENU_VIEW")}
							</Button>
						</Stack>
						{errorMessage?.template && (
							<Typography variant="body2" color="error">{errorMessage?.template}</Typography>
						)}
					</Stack>
				</AccordionDetails>
			</Accordion>
		</Box>
	);
};

export default InboundDependency;

const styles = {
	fpContainer: {
		// padding: "0 16px 16px 16px"
		padding: "0 4px 4px 4px",
	},
	accordianContainer: {
		border: "none",
		padding: "0",
		margin: "0",
		boxShadow: "none",
		backgroundColor: "unset",
	},
	accordianHeader: {
		border: "none",
		padding: "0",
		margin: "0",
		backgroundColor: "unset",
	},
	accordianContent: {
		border: "none",
		padding: "0 0px",
		margin: "0",
		backgroundColor: "unset",
	},
};